module.exports = __webpack_public_path__ + "img/logo.ef0cb1b3.png";